import { post, get } from '@/services/api';


export default {
  async login(context, data) {
    console.log('✅ login() triggered');
    console.log('Received data login:', JSON.stringify(data, null, 2));

    try {
      console.log('Calling POST /user/login...');
      const response = await post('/user/login', {
        mobile: data.mobile,
        password: data.password,
      });
      context.commit('setLoggedIn', true);
      console.log('✅ API Response:', response.data);
    } catch (error) {
      console.error('❌ Login API error:', error);
      throw new Error(error.response?.data?.message || 'Invalid mobile number or password.');
    }
  },
  async handleFetchRedirectUrl(context, data) {
    console.log('✅ fetchRedirectUrl() triggered');
    console.log('Received data fetchRedirectUrl:', JSON.stringify(data, null, 2));
  
    try {
      const response = await post(
        '/user/redirect-to-login',
        new URLSearchParams({ application: data.application }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          },
        }
      );
      console.log('✅ API Response:', response.data); // ✅ Display/log response
      return response.data; // Return to componentreturn response.data;
    } catch (error) {
      console.error('❌ Redirect URL API error:', error);
      throw error; // Let parent handle the error if needed
    }
  },
  async updateSessionToken(context,data){
    console.log('✅ updateSessionToken() triggered');
    console.log('Received data updateSessionToken:', JSON.stringify(data, null, 2));

    try {
      console.log('Calling POST /user/updateSessionToken...');
      const response = await post('/user/update-session-token', {
        application: data.application,
        sessionToken: data.token,
      });

      console.log('✅ API Response:', response.data);
    } catch (error) {
      console.error('❌ Login API error:', error);
    }
  },
  async addOrUpdateTradingApp(_, form) {
    const url = form.tradingUserId ? '/users/updateTradingApplication' : '/users/addTradingApplication';
    const res = await this.$axios.post(url, form);
    return res.data;
  },
  async getTradingApplications() {
    try {
      const res = await get('/user/get-trading-application-list');
      return res.data.tradingApplicationList;
    } catch (e) {
      console.error('❌ Failed to fetch trading apps:', e);
      throw e;
    }
  },
  

  async addTradingApplication(_, form) {
    try {
      console.log('✅ addTradingApplication() triggered');
      console.log('Received data addTradingApplication:', JSON.stringify(form, null, 2));
      const res = await post('/user/add-trading-application', form);
      return res.data;
    } catch (e) {
      console.error('❌ Failed to add trading app:', e);
      throw e;
    }
  },
  async updateTradingApplication(_, form) {
    console.log('✅ updateTradingApplication() triggered');
    console.log('Received data updateTradingApplication:', JSON.stringify(form, null, 2));
    try {
      const res = await post('/user/update-trading-application', form);
      return res.data;
    } catch (e) {
      console.error('❌ Failed to update trading app:', e);
      throw e;
    }
  } ,
  async registerUser(_, form) {
    try {
      console.log('✅ registerUser() triggered');
      console.log('Received data registerUser:', JSON.stringify(form, null, 2));
      const res = await post('/user/register-user', form);
      return res.data;
    } catch (e) {
      console.error('❌ Failed to register user:', e);
      throw e;
    }
  },

  // 👇 --- ADD THIS ACTION --- 👇
  logout(context) {
    console.log('✅ logout() triggered');
    context.commit('LOGOUT_USER');
  }
};



